<template>
	<div v-bind="$attrs" class="h-full w-full animate-spin">
		<IconButtonSpinner class="h-full w-full text-gray-50" />
	</div>
</template>

<script setup>
import IconButtonSpinner from '@/assets/svg/common/ico-button-spinner.svg'
</script>
